module.exports = __webpack_public_path__ + "assets/img/email.dd145ff3.svg";